import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import { useAuth } from '../../contexts/AuthContext';

// Porta única da administração. Cada card só aparece pra quem tem a permissão da área.
export default function AdminHub() {
  const { temPermissao } = useAuth();
  const algum = (...chaves) => chaves.some(c => temPermissao(c));

  const secoes = [
    {
      titulo: 'Conteúdo',
      itens: [
        { to: '/admin/avisos', icone: 'bi-megaphone', titulo: 'Avisos', desc: 'Publicar, editar e tirar do ar; ver quantos viram', ok: temPermissao('publicar_aviso') },
        { to: '/documentos/manuais', icone: 'bi-journal-text', titulo: 'Documentos', desc: 'Manuais, POPs e treinamentos da biblioteca', ok: temPermissao('editar_documento') },
        { to: '/admin/categorias', icone: 'bi-folder2', titulo: 'Categorias', desc: 'Organizar a biblioteca de documentos', ok: temPermissao('editar_documento') },
        { to: '/atas', icone: 'bi-journal-bookmark', titulo: 'Atas de Reunião', desc: 'Pastas, atas e as tarefas que saem delas', ok: temPermissao('gerir_atas') },
        { to: '/academia', icone: 'bi-mortarboard', titulo: 'Trilhas', desc: 'Montar, publicar e editar trilhas', ok: temPermissao('gerir_academia') },
        { to: '/admin/quizzes', icone: 'bi-patch-question', titulo: 'Quizzes', desc: 'Testes das trilhas: editar e excluir', ok: temPermissao('gerir_academia') },
      ],
    },
    {
      titulo: 'Pessoas',
      itens: [
        { to: '/admin/acessos', icone: 'bi-person-badge', titulo: 'Colaboradores e acessos', desc: 'Quem já entrou, papéis e reset de senha', ok: algum('gerir_colaboradores', 'gerir_perfis') },
        { to: '/admin/cargos', icone: 'bi-diagram-2', titulo: 'Cargos', desc: 'O que cada cargo do RH é dentro do portal', ok: algum('gerir_colaboradores', 'gerir_perfis') },
        { to: '/admin/organograma', icone: 'bi-diagram-3', titulo: 'Organograma', desc: 'Criar posições e definir quem fica onde', ok: algum('gerir_colaboradores', 'gerir_perfis') },
        { to: '/equipe', icone: 'bi-people', titulo: 'Acompanhamento', desc: 'Quem leu os documentos e concluiu as trilhas', ok: temPermissao('ver_equipe') },
      ],
    },
    {
      titulo: 'Segurança',
      itens: [
        { to: '/admin/seguranca', icone: 'bi-shield-check', titulo: 'Histórico de segurança', desc: 'Logins, senhas resetadas, papéis e cargos alterados', ok: algum('gerir_perfis', 'ver_seguranca') },
      ],
    },
  ].map(s => ({ ...s, itens: s.itens.filter(i => i.ok) })).filter(s => s.itens.length);

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 1000 }}>
        <div className="adm-topo">
          <div>
            <h1>Administração</h1>
            <p>Tudo que dá pra gerenciar no portal, num lugar só.</p>
          </div>
        </div>

        {secoes.length === 0 && (
          <div className="conteudo-card adm-vazio">Você não tem acesso a nenhuma área de administração.</div>
        )}

        {secoes.map(s => (
          <section key={s.titulo}>
            <div className="adm-hub-secao">{s.titulo}</div>
            <div className="adm-hub-grid">
              {s.itens.map(i => (
                <Link key={i.to} to={i.to} className="adm-hub-card">
                  <i className={`bi ${i.icone}`}></i>
                  <div>
                    <div className="adm-hub-card-titulo">{i.titulo}</div>
                    <div className="adm-hub-card-desc">{i.desc}</div>
                  </div>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </main>
    </>
  );
}
